import React from 'react';
import { trackFbEvent } from '../utils/fbpixel';
export function UrgencySection() {
  return <section className="w-full px-4 py-6 max-w-2xl mx-auto flex items-center" style={{
    minHeight: '100dvh',
    maxHeight: '852px'
  }} data-id="element-256">
      <div className="w-full" data-id="element-257">
        <div id="oferta" className="rounded-2xl px-5 py-6 text-center" style={{
        background: 'linear-gradient(135deg, rgba(255,0,110,0.15) 0%, rgba(255,0,110,0.03) 100%)',
        border: '1px solid rgba(255,0,110,0.3)'
      }} data-id="element-258">
          <span className="text-xl mb-1 block" data-id="element-259">⚡</span>
          <h3 className="text-[18px] font-bold text-white mb-2" data-id="element-260">
            OFERTA DE LANZAMIENTO
          </h3>
          <p className="text-[13px] text-brand-muted leading-snug mb-3" data-id="element-261">
            Este precio es de lanzamiento. Cuando alcancemos las primeras 200
            compradoras, el precio sube.
          </p>

          <div className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-white/[0.06] border border-white/[0.1] mb-3 text-[12px]" data-id="element-262">
            <span className="text-brand-magenta" data-id="element-263">🕐</span>
            <span className="text-white font-medium" data-id="element-264">
              Precio disponible por tiempo limitado
            </span>
          </div>

          <p className="text-brand-muted text-sm line-through mb-1" data-id="element-265">
            Valor real: $89.000
          </p>
          <p className="text-brand-magenta text-3xl font-bold mb-2" data-id="element-266">
            Hoy: $19.990
          </p>

          <p className="text-[13px] text-brand-muted leading-snug mb-4" data-id="element-267">
            Menos que 1 consulta privada. Menos que 1 caja de óvulos + 1 turno
            médico.
            <br data-id="element-268" />
            <strong className="text-white" data-id="element-269">Una sola vez. Para siempre.</strong>
          </p>

          <a href="https://biologiafemenina.com.ar/checkouts/cn/hWNAeqV0yEfjXTQWRwX8VpaM/en-ar?_r=AQABGMB2CxEnifw5C9gY_ytqQ9gwpUl2H2fKrzy8ZI9EeZQ" target="_blank" rel="noopener noreferrer" onClick={() => trackFbEvent('InitiateCheckout', {
          content_name: 'Urgency CTA',
          value: 19990,
          currency: 'ARS'
        })} className="inline-block w-full max-w-sm bg-brand-magenta hover:brightness-110 text-white font-bold text-[15px] rounded-xl py-3.5 px-6 text-center transition-all animate-pulse-slow shadow-lg shadow-brand-magenta/30" data-id="element-270">
            🔓 QUIERO EL MÉTODO pH-ZERO
            <span className="block text-[13px] font-normal mt-0.5 opacity-90" data-id="element-271">
              Acceso Inmediato
            </span>
          </a>
        </div>
      </div>
    </section>;
}